import { render, staticRenderFns } from "./UserTimeSaved.vue?vue&type=template&id=0b61b6dd"
import script from "./UserTimeSaved.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTimeSaved.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports